import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-t mt-2 pt-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, "Erro", -1)
const _hoisted_3 = { class: "text-amber-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_button = _resolveComponent("t-button")!
  const _component_dialog_modal = _resolveComponent("dialog-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", _mergeProps({
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, _ctx.$attrs), [
      _renderSlot(_ctx.$slots, "form", {
        onUpdate: _ctx.onUpdate,
        values: _ctx.values
      }, () => [
        _createTextVNode(" form ")
      ]),
      _withDirectives(_createElementVNode("hr", _hoisted_1, null, 512), [
        [_vShow, !_ctx.hideButtons]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([_ctx.submitFixed ? 'sticky bg-gray-100 rounded border' : '', "w-full p-2 mt-2 bottom-0"])
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["mr-2 mt-2 text-base px-4 py-1 inline-block rounded text-white focus:outline-none focus:ring-2", `bg-${_ctx.theme}-500 hover:bg-${_ctx.theme}-600 focus:ring-${_ctx.theme}-700`]),
          type: "submit"
        }, " Salvar ", 2),
        _createVNode(_component_t_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetForm(_ctx.initialValues))),
          color: "gray"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Desfazer")
          ]),
          _: 1
        }),
        (!_ctx.hideButtonBack)
          ? (_openBlock(), _createBlock(_component_t_button, {
              key: 0,
              color: "gray",
              onClick: _ctx.back
            }, {
              default: _withCtx(() => [
                _createTextVNode("Voltar")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "extraButtons")
      ], 2), [
        [_vShow, !_ctx.hideButtons]
      ])
    ], 16),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_dialog_modal, {
          key: 0,
          show: !!_ctx.error,
          onClose: _ctx.closeError
        }, {
          title: _withCtx(() => [
            _hoisted_2
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.error), 1)
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_t_button, { onClick: _ctx.closeError }, {
              default: _withCtx(() => [
                _createTextVNode(" Fechar ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["show", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}